import { Eye, EyeOff } from 'lucide-react';

/**
 * The show/hide control that sits in a password field's trailing slot.
 *
 * One component because there are two surfaces that need it — the create-user form's
 * `<PasswordFields>` and the forced password change — and a password field without a way to
 * read what was typed is how a reader ends up mistyping the same value into two boxes and
 * being told they do not match.
 *
 * It is **in the tab run**, unlike the modal chrome that is excluded from it: this is the only
 * keyboard path to reading the value back, so removing it would remove the function rather
 * than a duplicate of it.
 */
export function PasswordReveal({
  id,
  visible,
  onToggle,
}: {
  id: string;
  visible: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      id={id}
      onClick={onToggle}
      aria-label={visible ? 'Hide password' : 'Show password'}
      aria-pressed={visible}
      className="rounded-md p-1 text-slate-400 transition hover:bg-slate-100 hover:text-slate-600"
    >
      {visible ? (
        <EyeOff className="h-4 w-4" aria-hidden="true" />
      ) : (
        <Eye className="h-4 w-4" aria-hidden="true" />
      )}
    </button>
  );
}
